export const BASE_URL = process.env.VUE_APP_BASE_URL;

console.log("BASE URL", BASE_URL)

export const ACTIVO = "1"

export const INACTIVO = "0"

export const DASHBOARD = "DASHBOARD"

export const LOGIN = "LOGIN"

export const OK = "ok"
